import { render, staticRenderFns } from "./PathwayCohortViewActions.vue?vue&type=template&id=59ef6754&"
import script from "./PathwayCohortViewActions.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortViewActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports